module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAZIAAAABAQMAAADOybrgAAAABlBMVEUAAABHcEyA51bHAAAAAnRSTlMfALvJw6YAAAASSURBVAgdY0AA+f94wD8GBAAA9EsdAjUoXSkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/styles/common/img/nothing_bg.png
// module id = e+bf
// module chunks = 37